import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Sidebar from '../components/Sidebar';
import '../assets/styles/MainPage.css'; // Import the CSS for styling
import HeroImage from '../assets/images/main-illustration.svg'; // Import the SVG
import { useEffect } from 'react';

const MainPage = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  const handleButtonClick = () => {
    navigate('/manage-form'); // Navigate to the /manage-form page
  };
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
        navigate('/');
    }
}, [navigate]);
  return (
    <div className="main-page">
      <Sidebar />
      <div className="content">
        <div className="hero-section">
          <div className="hero-text">
            <h1>Shape the Future of Entrepreneurship</h1>
            <p>
              Empower your decisions with data-driven insights. Create forms, assign weights to criteria, and rank startup potential in seconds.
            </p>
            <button className="cta-button" onClick={handleButtonClick}>
              Create Your Form
            </button>
          </div>
          <div className="hero-image">
            <img src={HeroImage} alt="Illustration for entrepreneurship" /> {/* SVG Image */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage;